import { StringBundle } from '../localizer/stringBundle'

export const strings = {
  bundles: [StringBundle.BTF],
  strings: [
    'DV_DP_EL_episode_title_template',
    'DV_DP_EL_bonus_title_template',
    'DV_comma_separator',
  ] as const,
}